import React, { Component } from 'react';
import PropTypes from 'prop-types';

import poketypes from 'utils/poketypes';

class TypeBadge extends Component {
  render() {
    return (
      <div className="TypeBadge  d:b m-x:a fw:9 ls:m tt:u ta:c fz:mini lh:0 c:white" style={{
        marginBottom: '0.25rem',
        padding: '0.5rem',
        backgroundColor: poketypes[this.props.type].color,
        boxShadow: 'inset 0 -0.15rem 0.3rem rgba(0,0,0,0.15), inset 0 0 0 1px rgba(0,0,0,0.075), inset 0 1px 0 2px rgba(255,255,255,0.15)',
        textShadow: '0 -0.5px 1px rgba(0,0,0,0.75)',
        borderRadius: '4px',
        maxWidth: '90px'
      }}>
        {this.props.type}
      </div>
    );
  }
}

TypeBadge.propTypes = {
  type: PropTypes.oneOf(Object.keys(poketypes)).isRequired
}

export default TypeBadge;



// WEBPACK FOOTER //
// ./src/components/TypeBadge.js